import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const preqPartType = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/prerequisite/part-types',

        partCategories: [],
        partCategoriesLoading: false,
        partCategoryLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        partCategories: state => state.partCategories,
    },
};
